import { AppData, AppDataSummary } from '../app-data/app-data';
import { DateTime } from 'luxon';

export class MorningMinutesEditor {
  id: number;
  localId?: number;
  isCompleted: boolean;
  date: DateTime; // date here will always be the start of day
  meetingDate?: DateTime; // meeting date is the exact date time that the meeting took place
  maintenanceBreakdowns: string;
  commsText: string;
  commsPhone: boolean = true;
  commsInternet: boolean = true;
  commsNetwork: boolean = true;
  commsEmail: boolean = true;
  logistics: string;
  lowlightsChallenges: string;
  aob: string;
  meetingTime: string;
  meetingTimeOffset: number;
}

export class MorningMinutesReportPreviewData {
  appData: AppData;
  appDeletionData: AppDataSummary;
  morningMinutesEditor: MorningMinutesEditor;
}



// WEBPACK FOOTER //
// ./src/models/morning-minutes/morning-minutes.models.ts